export default {"src":"/_next/static/media/hatena.d8e70d28.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};